import React from "react";

/**
 * Aarya brandmark - the "Circle of Care" hand-drawn ink stroke.
 * Use this everywhere the brand identity appears (splash, header, profile, T&C, etc.)
 */
export default function AaryaMark({ size = 40, className = "", withBg = false }) {
  const inner = (
    <img
      src="/logos/02_circle.png"
      alt="Aarya"
      style={{ width: size, height: size, display: "block" }}
      className="object-contain"
      draggable={false}
    />
  );
  if (!withBg) return <div className={className}>{inner}</div>;
  return (
    <div
      className={`rounded-2xl bg-white flex items-center justify-center shadow-soft ${className}`}
      style={{ width: size + 8, height: size + 8 }}
    >
      {inner}
    </div>
  );
}

/** Wordmark + small mark side by side. Use sparingly - header, splash, T&C. */
export function AaryaLockup({ markSize = 40, tagline }) {
  return (
    <div className="flex items-center gap-3">
      <AaryaMark size={markSize}/>
      <div className="flex flex-col">
        <span className="font-display text-[26px] leading-none text-ink-900 tracking-tight">Aarya</span>
        {tagline && (
          <span className="text-[10px] tracking-[0.18em] uppercase text-ink-500 mt-1">{tagline}</span>
        )}
      </div>
    </div>
  );
}
